export default "__VITE_ASSET__b1b20335__"